import { render, staticRenderFns } from "./GstPayWithHoldingModal.vue?vue&type=template&id=b7a00bc6&scoped=true"
import script from "./GstPayWithHoldingModal.vue?vue&type=script&lang=js"
export * from "./GstPayWithHoldingModal.vue?vue&type=script&lang=js"
import style0 from "./GstPayWithHoldingModal.vue?vue&type=style&index=0&id=b7a00bc6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a00bc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7a00bc6')) {
      api.createRecord('b7a00bc6', component.options)
    } else {
      api.reload('b7a00bc6', component.options)
    }
    module.hot.accept("./GstPayWithHoldingModal.vue?vue&type=template&id=b7a00bc6&scoped=true", function () {
      api.rerender('b7a00bc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gstreport/GstPayWithHoldingModal.vue"
export default component.exports